import Utils from "@/utilities/Utils";
import { IBriefingSection, BriefingSection } from "./BriefingSection";
import { IPage, Page } from "./Page";
import { PathwayPage } from "./PathwayPage";

export interface IBriefingItemContainer {
    isMenuShowing: boolean;
    section?: IBriefingSection;
    page?: IPage;
}

const padNumber = (n: number|undefined) => String(n ?? 0).padStart(6, "0");

export class BriefingItemContainer implements IBriefingItemContainer {

    constructor(item: IBriefingItemContainer) {
        this.isMenuShowing = item.isMenuShowing;
        if (item.section) this.section = new BriefingSection(item.section);
        if (item.page) this.page = new Page(item.page);
    }

    isMenuShowing: boolean = false;
    section?: BriefingSection;
    page?: Page;

    get isSection(): boolean { return typeof this.section !== "undefined"; }
    get isPage(): boolean { return typeof this.section === "undefined" && typeof this.page !== "undefined"; }
    get id(): string { return this.isSection ? (this.section?.id ?? "--") : this.isPage ? (this.page?.id ?? "--") : Utils.createKey(3); }
    get description(): string { return this.isPage ? this.page?.description ?? "" : this.section?.description ?? ""; }
    get isQuiz(): boolean { return this.isPage ? (this.page?.isQuiz ?? false) : (this.section?.isQuiz ?? false); }
    get isExpanded(): boolean { return this.section?.isExpanded === true; }
    get displayOrder(): string { return this.isPage ? `${padNumber(this.page?.sectionDisplayOrder)}|${padNumber(this.page?.displayOrder)}` : `${padNumber(this.section?.displayOrder)}|`; }
    get pathways(): Array<PathwayPage> { return this.page?.pathways ?? []; }
}